import React from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import _ from 'underscore';
import cn from 'classnames';

import { Skeletons } from 'ui/components/skeleton';
import { Contract } from 'services/action';

const initialState = {
  priviledge: null,
  showDelete: false,
};

export const Action = ({ data, onSubmit }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const [{ showDelete, priviledge }, setState] = React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.contract',
    });
    setState((prevState) => ({ ...prevState, priviledge: x }));
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showApprove: false,
      showDelete: false,
    }));
  };

  const $handleDelete = async () => {
    const req = await Dispatch(Contract.$delete(data?.id));
    if (req?.message === 'success') {
      $handleClose();
      History.replace('/order/contract');
    }
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const StandardAction = () => {
    return priviledge?.action === 'manage' || !Session?.privileges ? (
      <>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
        >
          <Link
            to={`/order/contract/${data?.id}/update`}
            className={cn('btn btn-primary px-2')}
          >
            <Fi.FiEdit size="17" />
          </Link>
        </OverlayTrigger>
        {data?.document_status !== 'completed' && (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
          >
            <button
              className={cn('btn btn-danger px-2')}
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  showDelete: true,
                }))
              }
            >
              <Fi.FiTrash2 size="17" />
            </button>
          </OverlayTrigger>
        )}
      </>
    ) : null;
  };

  // const SettingAction = () => {
  //   return priviledge?.action === 'manage' || !Session?.privileges ? (
  //     <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
  //       <Dropdown.Toggle
  //         id="dropdown-autoclose-true"
  //         className="d-flex p-0 justify-content-between "
  //       >
  //         <OverlayTrigger
  //           placement="bottom"
  //           overlay={<Tooltip id={`tooltip-top`}>Pengaturan</Tooltip>}
  //         >
  //           <div
  //             className=" border-end border-light"
  //             style={{ padding: '4.4px 8px' }}
  //           >
  //             <Fi.FiSettings size="17" className=" border-end" />
  //           </div>
  //         </OverlayTrigger>
  //       </Dropdown.Toggle>

  //       <Dropdown.Menu className="py-0 rounded-2">
  //         <div
  //           className="dropdown-item d-flex align-items-center text-danger  cursor-pointer  "
  //           onClick={() =>
  //             setState((prevState) => ({
  //               ...prevState,
  //               showDelete: true,
  //             }))
  //           }
  //         >
  //           <Fi.FiX size={15} color="#FF1818" className="me-2" />
  //           Hapus kontrak
  //         </div>
  //       </Dropdown.Menu>
  //     </Dropdown>
  //   ) : null;
  // };

  // const PrintAction = () => {
  //   return (
  //     <OverlayTrigger
  //       placement="bottom"
  //       overlay={<Tooltip id={`tooltip-top`}>Print</Tooltip>}
  //     >
  //       <Link
  //         to={`/print/contract/${data?.id}`}
  //         className={cn('btn btn-primary px-2')}
  //       >
  //         <Fi.FiPrinter size="17" />
  //       </Link>
  //     </OverlayTrigger>
  //   );
  // };

  return (
    <div className="d-flex align-items-center gap-1 px-3 px-md-0 pb-2 pb-md-0">
      {StateLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          <StandardAction />
          {/* <SettingAction /> */}
          {/* {data?.document_status === 'approved' && <PrintAction />} */}
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
